import { Settings } from "../../Settings"
import { TypeEvent, TypeEventResult } from "@lexriver/type-event"
import { Async } from "@lexriver/async"
import { PopupAsync } from "../popups/PopupAsync"
import { DomeRouter } from "@lexriver/dome"
import { UrlGenerator } from "../UrlGenerator"
import { JsonPack } from "@lexriver/json-pack"
//import RobustWebsocket from 'robust-websocket'
const RobustWebsocket = require('robust-websocket')

const filename = 'RequestMaker'

interface WebsocketResponseSuccess{
    success?:boolean
    result: any
    request: string
}

interface WebsocketResponseError{
    error:string|number,
    success?:boolean
    request:string
}

export interface WebsocketJsonRequest{
    query:string,
    params?:any
}

export enum EnumWebsocketPushMessages{
    BasketQuantityUpdate = 'basket-quantity-update',
    BasketClear = 'basket-clear',
    BasketCouponsUpdate = 'basket-coupons-update',
    FavoritesUpdate = 'favorites-update',
    BasketStats = 'basket-stats'
}

interface WebsocketPushMessage{
    pushMessage:string
    params?:any
}

//type WebsocketResponse = WebsocketResponseSuccess & WebsocketResponseError


export enum EnumRequestPrefix{
    Rest = 'rest',
    Websocket = 'ws'
}

export module RequestMaker{
    function getUrlForPrefix(type:EnumRequestPrefix){
        if(type == EnumRequestPrefix.Rest){
            return Settings.restServerAddress
        }
        if(type == EnumRequestPrefix.Websocket){
            return Settings.websocketRestServerAddress
        }
        throw new Error('not implemented')
    }

    export async function getJsonAsync(query:string, prefix:EnumRequestPrefix = EnumRequestPrefix.Rest){
        try {
            const resp = await fetch(`${getUrlForPrefix(prefix)}${query}`)
            const data = await resp.json()
            return data
        }catch(x){
            console.error('GET json request', query, 'failed with error', x)
        }
        return undefined
    }


    async function makeJsonRequestAsync(
        url:string, 
        options:RequestInit,
        json:any = {}
    ){
        //#region add .sessionId to each request. for dev only
        //if(!Settings.isProduction){
            //json.sessionId = localStorage.getItem(Settings.localStorageKey_SessionId)
            //json.sessionId = GlobalUser.sessionIdO.get()
        //}
        //#endregion

        try {
            const response = await fetch(
                url, {
                    ...options, 
                    headers: {
                        'Content-Type': 'application/json'
                    }, 
                    //credentials: 'same-origin', 
                    //credentials: "include", //TODO:
                    //mode: 'cors', //TODO:
                    body: JSON.stringify(json)
                })
            return await response.json(); 
        }catch(x){
            console.error(options.method, 'request failed', url, 'error=', x)
        }
    }

    export async function postJsonAsync(query, json:any, prefix:EnumRequestPrefix = EnumRequestPrefix.Rest){
        //['X-Requested-With'] ='XMLHttpRequest'
        return await makeJsonRequestAsync(getUrlForPrefix(prefix)+query, {
            method: 'POST',
            cache: 'no-cache',
            redirect: 'follow',
            referrerPolicy: 'no-referrer'
        }, json)
    }



    export const onWebsocketMessageEvent = new TypeEvent<(json:WebsocketResponseError|WebsocketResponseSuccess|WebsocketPushMessage)=>void>()
    let ws:WebSocket|null = null

    export function disconnectWebsocket(){
        //eventOnWebsocketDisconnect.unsubscribeAll()
        ws?.close()
    }

    //const eventOnWebsocketDisconnect = new TypeEvent<(p:{abnormal:boolean, sessionId?:string}) => TypeEventResult>()

    let isConnected:boolean = false

    //if(Settings.autoReconnect){
    // eventOnWebsocketDisconnect.subscribe(async (e) => {
    //     console.error('websocket disconnected, trying to reconnect')
    //     //if(e.abnormal){
    //         while(isConnected === false){
    //             await Async.waitMsAsync(3000)
    //             initWebsocket()
    //         }
    //     //}
    // })
    //}

    let prevSessionId:string|undefined = undefined

    export function initWebsocket(sessionId?:string){
        console.log('initWebsocket')
        //return new Promise((resolve, reject) => {
        if(sessionId){
            prevSessionId = sessionId
        }

            if(ws){
                ws.close()
            }
            if(ws){
                ws.onopen = null
                ws.onclose = null
                ws.onerror = null
                ws.onmessage = null
            }
            ws = null
            //let sessionId=GlobalUser.sessionIdO.get()
            //console.log(filename, 'initWebsocket', sessionId)
            //ws = new WebSocket(Settings.getWebsocketServerAddress(sessionId))
            ws = new RobustWebsocket(Settings.getWebsocketServerAddress(sessionId), null, {
                shouldReconnect: function(event, ws) {
                    //if (event.code === 1008 || event.code === 1011) return
                    //return [0, 3000, 10000][ws.attempts]
                    return Math.pow(1.5, ws.attempts) * 500
                },
            })
            if(!ws) throw new Error()
    
            //ws.addEventListener('open', (e) => {
            ws.onopen =  (e) => {
                //console.log('ws: on open', 'sessionId=', sessionId)
                isConnected = true
                //resolve()
            }
    
            //ws.addEventListener('close', (e) => {
            ws.onclose = async (e) => {
                //console.log('ws: on close', e.code, e.reason)
                isConnected = false
                //ws = null
                // https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/close
                // https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent
    
                //eventOnWebsocketDisconnect.triggerAsync({abnormal: e.code !== 1005, sessionId: sessionId})

                // reconect
                // while(isConnected === false){
                //     await Async.waitMsAsync(3000)
                //     initWebsocket(sessionId)
                // }

            }

            //ws.addEventListener('message', (e) => {
            ws.onmessage = async (e) => {
                //console.log('ws: event from server', e.data)
                try {
                    const json = JSON.parse(e.data)
                    if(json.error){
                        console.warn('ws: received json with error', json)
                        
                        if(json.error == 500){
                            await reportBugAsync(json)
    
                        } else if(json.error == 401){ //invalid session (old, etc)
                            //console.log('#### catch 401, relogin!', 'json=', json)
                            DomeRouter.navigate(UrlGenerator.relogin)
                        }
    
                    } else {
                        // console.log('ws: received json = ', json)
                    }
                    await onWebsocketMessageEvent.triggerAsync(json)
    
                } catch(x){
                    console.error('ws: unable to parse message', e.data, 'error=', x)
                }
            }
            ws.addEventListener('error', (e) => {
                console.error('ws: error', e)
            })
    
        //})
    }
    // initWebsocket() // !now is called from GlobalUser!


    // so we have two type of outgoing messages:
    // 1) /get-product/123
    // 2) {query:'get-product', params:{productId:123}}
    //
    // and we have three types of incoming messages:
    // 1) {success: true, result: {...}, query:'...' }
    // 2) {error: 'error-message', query: '...'}
    // 3) {push:true, query:'basket-updated', params:{...} }
    //
    // so we have three scenarious:
    // 1) send route request and get response (bad or good)
    // 2) send json request and get response (bad or good)
    // 3) just subscribe to push message

    export async function sendWebsocketRouteRequestAsync(routeQuery:string, who:any):Promise<any>{
        if(routeQuery.startsWith('/') == false) throw new Error('wrong routeQuery: '+routeQuery)
        return await sendWebsocketMessageAndWaitForReplyAsync(routeQuery, who)
    }

    export async function sendWebsocketJsonRequestAsync<T>(jsonQuery:WebsocketJsonRequest, who: any):Promise<T>{
        //jsonQuery['sessionId'] = GlobalUser.sessionIdO.get()
        if(jsonQuery.params && !jsonQuery.params.host){
            jsonQuery.params.host = Settings.getCurrentDomain()
        }
        return await sendWebsocketMessageAndWaitForReplyAsync(JSON.stringify(jsonQuery), who)
    }

    export function subscribeToPushMessage(pushMessageType:EnumWebsocketPushMessages, action:(params:any)=>void){
        // console.log('RequestMaker', 'subscribing to push message', pushMessageType)
        onWebsocketMessageEvent.subscribe((json) => {
            const jsonAsPushMessage = json as WebsocketPushMessage
            if(jsonAsPushMessage.pushMessage && jsonAsPushMessage.pushMessage == pushMessageType){
                // console.log('RequestMaker', 'got push message', jsonAsPushMessage)
                action(jsonAsPushMessage.params)
            }
        })
    }



    
    async function sendWebsocketMessageAndWaitForReplyAsync<T>(query:string, who:any):Promise<T>{
        await sendWebsocketMessageAsync(query, who)
        return new Promise((resolve, reject) => {
            onWebsocketMessageEvent.subscribe((json:WebsocketResponseError|WebsocketResponseSuccess|WebsocketPushMessage)=>{
                //console.log('ws subscriber', 'json=', json)
                if(json['request'] !== query) return // we are waiting for reply only to our request
                const jsonAsSuccess = json as WebsocketResponseSuccess
                const jsonAsError = json as WebsocketResponseError
                if(jsonAsSuccess.success){
                    //console.log('jsonAsSuccess.result', typeof jsonAsSuccess.result, jsonAsSuccess.result)
                    if(typeof jsonAsSuccess.result === 'string' && jsonAsSuccess.result.startsWith('JsonPack:')){
                        // unpack first
                        let result = JsonPack.unpack(jsonAsSuccess.result)
                        //console.log('unpack result=', result)
                        resolve(result)
                    } else {
                        resolve(jsonAsSuccess.result)
                    }

                } else if(jsonAsError.error){
                    reject(jsonAsError.error)

                }
                return {unsubscribe:true}
            })
        })
    }

    
    async function reportBugAsync(json:any){
        try {
            await sendWebsocketJsonRequestAsync({query:'bug-report', params:{json}}, filename)
            await PopupAsync.showPopupAsync(() => 'На сервере произошла ошибка. Отчет об ошибке был автоматически отправлен. Пожалуйста, попробуйте еще раз позже.')
            
        } catch(x){
            await PopupAsync.showPopupAsync(() => `На сервере произошла ошибка. Пожалуйста сообщите об этом по любому адресу из раздела контакты. Технические подробности ошибки: ${x} json=${JSON.stringify(json)}`)
        }
        
    }

    async function sendWebsocketMessageAsync(query:string, who:any){
        if(!who) {
            console.error('sendWebsocketMessageAsync() failed, provide who', 'query=', query)
            throw new Error()
        }
        while(ws?.readyState !== WebSocket.OPEN){
            await Async.waitMsAsync(200)
            // if(ws?.readyState !== WebSocket.OPEN){
            //     reconnect()
            // }
            // await Async.waitMsAsync(500)
            console.log('ws readyState = ', ws?.readyState, 'waiting for connection...')
        }
        //console.log('ws: send query:', query, 'who=', who)
        ws?.send(query)
    }

    // async function reconnect(){
    //     console.log('reconnecting to websocket')
    //     initWebsocket(prevSessionId)
    // }

    

}